import { render } from "./kline.vue?vue&type=template&id=1e151397"
import script from "./kline.vue?vue&type=script&lang=js"
export * from "./kline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__